function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { useField, useFormikContext } from 'formik';
import GenericFormElement from '../GenericFormElement';
const FormCheckbox = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    name,
    label,
    onBlur,
    onChange,
    defaultValue,
    verticalSpacing,
    visualValidation,
    description,
    optionalLabel,
    isLiveValidationDisabled,
    isToggle,
    isFilter,
    expanded,
    tooltip,
    className,
    ...rest
  } = props;
  const [field, meta, helpers] = useField(name);
  const {
    submitCount
  } = useFormikContext();

  /**
   * @TODO for a breaking change: use union types to ensure mutual exclusivity
   */
  let fieldType = 'checkbox';
  if (isToggle) {
    fieldType = 'toggle';
  }
  if (isFilter) {
    fieldType = 'filterCheckbox';
  }
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    name: name,
    label: label,
    meta: meta,
    helpers: helpers,
    className: className,
    defaultValue: defaultValue,
    visualValidation: visualValidation,
    verticalSpacing: verticalSpacing,
    description: description,
    fieldType: fieldType,
    tooltip: tooltip,
    optionalLabel: optionalLabel,
    expanded: expanded,
    submitCount: submitCount,
    isLiveValidationDisabled: isLiveValidationDisabled
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: ref,
    id: name,
    checked: field.value,
    type: "checkbox"
  }, rest, field, {
    "aria-describedby": meta.touched && meta.error ? "".concat(name, "-error") : '',
    onBlur: e => {
      if (onBlur) onBlur(e);
      field.onBlur(e);
    },
    onChange: e => {
      if (onChange) onChange(e);
      field.onChange(e);
    }
  })));
});
export default FormCheckbox;